import { IResourceHalfSection } from 'interfaces/components/resources';

const ResourceHalfSection = ({ title, children }: IResourceHalfSection) => (
  <div className='w-1/2'>
    <div className='text-[20px] font-semibold pb-3 border-b border-gray-300 dark:border-gray-850'>
      {title}
    </div>
    <div className='mt-3 flex flex-wrap gap-4'>{children}</div>
  </div>
);

export default ResourceHalfSection;
